import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccountingBills = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "accounting-bills" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M4.125,7.5a.375.375,0,1,1-.375.375A.375.375,0,0,1,4.125,7.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.875,12.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .75,
			y: 4.5,
			width: 19.5,
			height: 12,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 10.5,
			cy: 10.5,
			r: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.25,9v9a1.5,1.5,0,0,1-1.5,1.5H5.25"
		})
	]
});
export default SvgAccountingBills;
